import { gql } from '@apollo/client';

const FETCH_EPC_USER_INFORMATION = gql`
    query fetchEpcUserInformation {
        fetchEpcUserInformation {
            userId,
            redirect {
                type,
                url
            },
            errors,
            userInformation {
                firstName,
                lastName,
                asciiFirstName,
                asciiLastName,
                email,
                phoneNumber,
                phoneCountryCode
            }
        }
    }
`;

const IS_PAPER_CONTRACT_USER = gql`
    query isEpcPaperContractUser {
        isEpcPaperContractUser
    }
`;

export {
    FETCH_EPC_USER_INFORMATION,
    IS_PAPER_CONTRACT_USER
};
